// @flow
import type { OptionType } from '../../../components/types'

export type State = {|
  isOpen: boolean,
  isLoading: boolean,
  name: string,
  url: string,
  login: string,
  password: string,
  options: Array<OptionType>,
  nameErrors: Array<string>,
  urlErrors: Array<string>,
  loginErrors: Array<string>,
  passwordErrors: Array<string>
|}

type InitialAction = {|
  +type: 'PRICELIST_EDIT.INIT',
  +state: $Shape<State>
|}

type PatchAction = {|
  +type: 'PRICELIST_EDIT.PATCH',
  +state: $Shape<State>
|}

type ResetAction = {|
  +type: 'PRICELIST_EDIT.RESET'
|}

type Action = InitialAction | PatchAction | ResetAction

const initialState = {
  isOpen: false,
  isLoading: false,
  name: '',
  url: '',
  login: '',
  password: '',
  options: [],
  nameErrors: [],
  urlErrors: [],
  loginErrors: [],
  passwordErrors: []
}

export function init(state: $Shape<State>): InitialAction {
  return {
    type: 'PRICELIST_EDIT.INIT',
    state
  }
}

export function patch(diff: $Shape<State>): PatchAction {
  return {
    type: 'PRICELIST_EDIT.PATCH',
    state: diff
  }
}

export function reset(): ResetAction {
  return {
    type: 'PRICELIST_EDIT.RESET'
  }
}

function fromInitial(initial: State): State {
  return {
    isOpen: initial.isOpen || false,
    isLoading: initial.isLoading || false,
    name: initial.name || '',
    url: initial.url || '',
    login: initial.login || '',
    password: initial.password || '',
    options: initial.options || [],
    nameErrors: initial.nameErrors || [],
    urlErrors: initial.urlErrors || [],
    loginErrors: initial.loginErrors || [],
    passwordErrors: initial.passwordErrors || []
  }
}

export default function reducer(state: State = initialState, action: Action) {
  switch (action.type) {
    case 'PRICELIST_EDIT.INIT': {
      return fromInitial(action.state)
    }
    case 'PRICELIST_EDIT.PATCH': {
      return { ...state, ...action.state }
    }
    case 'PRICELIST_EDIT.RESET': {
      return initialState
    }
    default:
      return state
  }
}
